/**
 * Shared Home Design Event route path used by client and route modules.
 */
export const HDE_PAGE_PATH = '/home-design-event';

/** Inline validation shown when the user tries to continue without ticking HDE marketing consent. */
export const HDE_MARKETING_CONSENT_ERROR_MESSAGE =
    'Please tick the box to continue with registration';

/**
 * Shown (toast + blocked view) when an invited event guest tries to start a primary
 * registration for the same event. They can only register on their own once the person who
 * invited them cancels the guest invitation.
 */
export const HDE_EVENT_GUEST_BLOCK_MESSAGE =
    "You're already registered as a guest for this event, so you can't also register as a primary attendee. To register on your own instead, ask the person who invited you to cancel your guest invitation first.";

/** Message shown when an invited guest email is already registered for the event. */
export const HDE_GUEST_EMAIL_ALREADY_REGISTERED_MESSAGE =
    'This email is already registered for this event.';
export const HDE_MODAL_PARAM = 'hde-modal';
export const HDE_SUBMITTED_PARAM = 'hde-submitted';
export const HDE_EVENT_ID_PARAM = 'hde-event-id';
